import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { Progress } from 'react-sweet-progress';
import "react-datepicker/dist/react-datepicker.css";
import "react-sweet-progress/lib/style.css";
import { DialogComponent } from '@syncfusion/ej2-react-popups';


class ImportExportWholeProject extends Component {
  constructor() {
    super();

    this.state = {
      successResp: false,
      buttonDisable: true,
      hideChoseFile: false,
      percentage: 0,
      progressStatus: null,
      showImportWholeProjectPopup: false,
      showImportConfirmPopup: false,
      showIncorrectPassword: false,
      exportProgressStatus: null,
      exportPercentage: 0,
      exportButtonDisable: false,
      displayExportStatus: false
    }

    this.dialogClose = () => {
      this.setState({
        showImportWholeProjectPopup: false
      });
    };

    this.importConfirmClose = () => {
      this.setState({ showImportConfirmPopup: false });
    };

    this.incorrectPwddialogClose = () => {
      this.setState({ showIncorrectPassword: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.importWholeProjectBtn = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true
      }, 'click': props => {
        this.setState({ showImportConfirmPopup: true, showImportWholeProjectPopup: false });
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ showImportWholeProjectPopup: false });
      }
    }];

    //importConfirmButtn
    this.importConfirmBtn = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.importInputValidation()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          showImportConfirmPopup: false,
        });
      }
    }];

    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          showIncorrectPassword: false

        })
      }
    }];
  }

  componentWillUnmount() {
    clearTimeout(window.importStatusTimeoutHandle);
    clearTimeout(window.exportStatusTimeoutHandle);
  }

  importInputValidation = () => {
    if (document.getElementById('importInputFromUser').value == "Import" ||
      document.getElementById('importInputFromUser').value == "import" ||
      document.getElementById('importInputFromUser').value == "IMPORT") {
      document.getElementById('importInputFromUser').value = "";
      this.importWholeProjectApi();
    }
    else {
      this.setState({
        showIncorrectPassword: true
      })
    }
  }

  notifyFailToCreate() {
    toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
      position: "top-center",
      color: "red"

    });
  }

  notifySuccessToast(response) {
    toast.dismiss();
    toast(<b>
      <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;{response}</b>, {
      position: "top-center"
    });
  }

  notifyFileNotPresent(response) {
    toast.dismiss();
    toast(<b>
      <img
        src="assets/images/warn.svg"
        style={{ paddingRight: "0px", height: "20px", width: "20px" }}
        content=""
      />
      &nbsp;&nbsp;{response}</b>, {
      position: "top-center"
    });
  }

  notifyErrorToast(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  downloadApi = () => {
    var importExportController = this;
    importExportController.state.exportButtonDisable = true;
    importExportController.state.displayExportStatus = true;
    importExportController.setState(importExportController.state);
    window.exportStatusTimeoutHandle = setInterval(function () {
      importExportController.fetchProjectExportStatusApi();
    }, 1000);
    $.ajax(
      {
        url: "/api/project-download-zip",
        async: true,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId')
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            clearTimeout(window.exportStatusTimeoutHandle);
            const fileName = res.result.fileName;
            const link = document.createElement('a');
            link.href = 'data:text/plain;base64,' + res.result.data;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            importExportController.state.exportPercentage = 100;
            importExportController.state.exportButtonDisable = false;
            importExportController.setState(importExportController.state);
          } else {
            clearTimeout(window.exportStatusTimeoutHandle);
            importExportController.notifyErrorToast(res.result);
            importExportController.state.exportProgressStatus = "error";
            importExportController.state.exportPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          } else if (xhr.status == 500) {
            clearTimeout(window.exportStatusTimeoutHandle);
            importExportController.notifyFailToCreate();
            importExportController.state.exportProgressStatus = "error";
            importExportController.state.exportPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        }
      }
    );
  }


  importWholeProjectApi = () => {
    var importExportController = this;
    importExportController.state.showImportWholeProjectPopup = false;
    importExportController.state.showImportConfirmPopup = false;
    importExportController.state.showIncorrectPassword = false;
    importExportController.state.hideChoseFile = true;
    importExportController.state.buttonDisable = false;
    importExportController.setState(importExportController.state);

    var formData = new FormData();
    formData.append("projectIdString", localStorage.getItem("currentProjectId"));
    formData.append("contentType", "ALL_CONTENT")
    formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
    formData.append('document', $('#inputFile')[0].files[0]);
    var uploadTimer = setInterval(function () {
      clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/project-content-import',
        type: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
          if (data.success === true) {
            window.importStatusTimeoutHandle = setInterval(function () {
              importExportController.fetchProjectImportStatusApi(data.result);
            }, 1000);
            importExportController.notifySuccessToast("Importing whole project initiated");
          } else {
            clearTimeout(window.importStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.progressStatus = "error";
            importExportController.state.percentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status === 401) {
            window.location.href = "/platform/";
          } else if (xhr.status == 500) {
            clearTimeout(window.importStatusTimeoutHandle);
            importExportController.notifyFailToCreate();
            importExportController.state.progressStatus = "error";
            importExportController.state.percentage = 100;
            importExportController.setState(importExportController.state);
          }
        }
      });
    }, 2000);
  }

  fetchProjectImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/project-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.percentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importStatusTimeoutHandle);
            importExportController.state.buttonDisable = true;
            importExportController.setState(importExportController.state);
            importExportController.notifySuccessToast("Project imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.buttonDisable = true;
            importExportController.state.progressStatus = "error";
            importExportController.state.percentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status === 401) {
          window.location.href = "/";
        } else if (xhr.status == 500) {
          importExportController.notifyFailToCreate();
          importExportController.state.buttonDisable = true;
          importExportController.state.progressStatus = "error";
          importExportController.state.percentage = 100;
          importExportController.setState(importExportController.state);
          clearTimeout(window.importStatusTimeoutHandle);
        }
      }
    });
  }

  fetchProjectExportStatusApi = () => {
    let importExportController = this;
    $.ajax({
      url: "/api/project-export-status",
      type: 'GET',
      async: true,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        projectId: localStorage.getItem('currentProjectId')
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.exportPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.exportStatusTimeoutHandle);
            importExportController.state.exportButtonDisable = false;
            importExportController.setState(importExportController.state);
          } else if (res.status == 'ERROR') {
            importExportController.state.exportButtonDisable = true;
            importExportController.state.exportProgressStatus = "error";
            importExportController.state.exportPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.exportStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        } else if (xhr.status == 500) {
          importExportController.notifyFailToCreate();
          importExportController.state.exportButtonDisable = true;
          importExportController.state.exportProgressStatus = "error";
          importExportController.state.exportPercentage = 100;
          importExportController.setState(importExportController.state);
          clearTimeout(window.exportStatusTimeoutHandle);
        }
      }
    });
  }

  refreshData = () => {
    var importExportController = this;
    importExportController.state.hideChoseFile = false;
    document.getElementById("inputFile").value = null;
    importExportController.setState(importExportController.state);
  }

  handleImportWholeProject = () => {
    if ($('#inputFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose file before import");
    } else {
      this.setState({ showImportWholeProjectPopup: true })
    }
  }

  render() {
    return (
      <div visible={(this.state.successResp) ? false : true}>
        <div style={{
          background: "#F9F9FB", marginLeft: '1%', marginRight: '1%'
        }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />

          {/* /.content-header */}
          <div className="content">
            <div className="container-fluid" >
              <div className="row"
                style={{ marginRight: '2%' }}  >
                <div className="col-lg-6" >
                  <div className="card" style={{ height: '150px' }}>
                    <div textAlign="center"  >
                      <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px', marginLeft: "10px", align: "center" }}>Import File</h6>
                    </div>
                    <br />
                    <div className="row">
                      <div style={{ width: "50%" }}>
                        <input type="file" id="inputFile" title="Choose file"
                          style={{
                            color: "black", marginTop: "10px", width: '90%', marginLeft: '10%',
                            display: this.state.hideChoseFile ? 'none' : 'block'
                          }} />
                        <Progress
                          style={{
                            display: this.state.hideChoseFile ? 'block' : 'none', marginTop: "20px",
                            width: '90%', marginLeft: '10%'
                          }}
                          rectBorderRadius="1px"
                          status={this.state.progressStatus}
                          percent={this.state.percentage}
                        />
                      </div>
                      <div style={{ width: "50%" }} align="center">
                        <button className="btn action-button" style={{ width: "90%", marginRight: '10%', }} onClick={this.handleImportWholeProject}
                          disabled={!this.state.buttonDisable}
                        >  Import</button></div>
                    </div>
                  </div>

                  <ToastContainer className="Toast-at-center" />
                </div>
                <div>
                </div>
                <div class="col-lg-6" >
                  <div className="card" style={{ height: '150px' }}>
                    <div style={{ align: "center", marginLeft: "10px" }}>
                      <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Export File</h6>
                    </div>
                    <br />

                    <div className='row'>
                      <Progress
                        style={{
                          display: this.state.displayExportStatus ? 'block' : 'none',
                          marginTop: "20px", width: "40%", marginLeft: '10%'
                        }}
                        rectBorderRadius="1px"
                        status={this.state.exportProgressStatus}
                        percent={this.state.exportPercentage}
                      />
                      <div style={{ width: "50%" }} align='center'>
                        <button className="btn action-button"
                          style={{
                            marginLeft: this.state.displayExportStatus ? '0px' : '50%',
                            width: "90%"
                          }}
                          disabled={this.state.exportButtonDisable}
                          onClick={this.downloadApi}>Export</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        <DialogComponent width='400px' animationSettings={this.settings}
          header='Import Whole Project' showCloseIcon={true} buttons={this.importWholeProjectBtn}
          ref={dialog => this.dialogInstance = dialog}
          visible={this.state.showImportWholeProjectPopup} close={this.dialogClose}>
          <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;Are you sure you want to override the whole project content?<br />Note: Press 'Yes' to override or press 'No' to decline.
        </DialogComponent>

        <DialogComponent width='400px' animationSettings={this.settings}
          header='Import Confirmation' showCloseIcon={true} buttons={this.importConfirmBtn}
          ref={dialog => this.dialogInstance = dialog}
          visible={this.state.showImportConfirmPopup} close={this.importConfirmClose}>
          Please type "Import" for confirmation<input type="text" id="importInputFromUser" />
        </DialogComponent>

        {/*Dialog Component For  Incorrect Password*/}
        <DialogComponent width='400px' animationSettings={this.settings}
          header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
          ref={dialog => this.dialogInstance = dialog}
          visible={this.state.showIncorrectPassword} close={this.incorrectPwddialogClose}>
          Please type "Import"
        </DialogComponent>
      </div >

    )
  }
}
export default ImportExportWholeProject;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/importExport/ImportExportWholeProject.js